import React, { useEffect, useLayoutEffect, useState } from 'react'
import {
  Row,
  Col,
  Tabs,
  Card,
  Menu,
  Button,
  Dropdown,
  Modal,
  Radio,
  Form,
} from 'antd'
import questionMark from 'assets/images/icons/question.png'
import { connect } from 'react-redux'
import { DropdownIco, ModalCloseIco } from '../../../../../modules/CustomIcons'
import QrCodeIos from '../../../../../assets/images/qrcode_ios.png'
import QrCodeAndroid from '../../../../../assets/images/qrcode_android.png'
import QrCodeWindows from '../../../../../assets/images/qrcode_windows.png'
import {
  secureLocalStorageGet,
  secureLocalStorageSet,
} from '../../../../helpers'
import { useTranslation } from 'react-i18next'
import QRCode from 'qrcode.react'

const languages = [
  {
    label: 'AZ',
    active: false,
  },
  {
    label: 'EN',
    active: false,
  },
  {
    label: 'RU',
    active: false,
  },
]

const activateModalVisibleReset = {
  showStep1: false,
  showStep2: false,
  showStep3: false,
  showStep4: false,
  showStep5: false,
  showStep6: false,
}

const qr_codes = {
  1: QrCodeAndroid,
  2: QrCodeIos,
  3: QrCodeWindows,
}

const options = [
  {
    label: 'Android',
    value: 1,
  },
  {
    label: 'iPhone',
    value: 2,
  },
  {
    label: 'Windows',
    value: 3,
  },
]

import InputField from 'components/InputField'
import SuccessOrErrorModal from 'components/SuccessOrErrorModal'
import {
  checkGoogleAuthSmsCode,
  CheckSmsCodeRequest,
  disableGoogleAuth,
  enableGoogleAuth,
  googleAuthCodeVerify,
} from '../../../../services/Auth/GoogleAuth'
import { getUserData } from '../../../../services/user'
import Timer from 'components/Timer'
import { resetForm } from '../../../../services/helper'
import {
  getLoggedUserInfo,
  getUserInfo,
} from '../../../../services/Auth/GetUserInfo'
import asanLogo from 'assets/images/icons/asan-logo.png'
import GoogleAuthenticator from 'pages/Settings/components/GoogleAuthenticator'
import { EyeIcon, ClosedEyeIcon } from '../../../../../modules/CustomIcons'
import { getSecretKey,getSecretKeyVerify } from '../../../../services/info'
import OtpInput from 'react-otp-input'
import Tooltip from 'components/Tooltip'
import { LOGIN_PAGE } from 'constants/constants'
import { CountdownCircleTimer } from 'react-countdown-circle-timer'

const Profile: React.FC<any> = ({ leftMenuStatus }) => {
  const { t } = useTranslation()
  const [form] = Form.useForm()
  const [googleAuthStatus, setGoogleAuthStatus] = useState<boolean>(false)
  const [activateModalVisible, setActivateModalVisible] = useState(
    activateModalVisibleReset
  )
  const [optionValue, setOptionValue] = useState(1)
  const [selectedOptionRow, setSelectedOptionRow] = useState(
    options.find((row) => row.value == optionValue)
  )
  const [visibleQrCode, setVisibleQrCode] = useState(false)
  const [showQrCode, setShowQrCode] = useState<boolean>(false)
  const [smsCode, setSmsCode] = useState<number>()
  const [googleAuthActivateCode, setGoogleAuthActivateCode] = useState<number>()
  const [QrCode, setQrCode] = useState<string>('')
  const [QrCodeImage, setQrCodeImage] = useState<string>('')
  const [loggedUserInfo, setLoggedUserInfo] = useState<getUserInfo>()
  const [smsCodeFieldErrorText, setSmsCodeFieldErrorText] = useState(false)
  const [smsClicked, setClicked] = useState(false)
  const [otpCodeModalVisible, setOtpCodeModalVisible] = useState(false)
  const [asanModalVisible, setAsanModalVisible] = useState(false)
  const [phoneNumber, setPhoneNumber] = useState<string>()
  const [secretWord, setSecretWord] = useState(false)
  const [nextModalVisible, setNextModalVisible] = useState(false)
  const [showSecretWord,setShowSecretWord] = useState(false)
  const [otpCode, setOtpCode] = useState<number[]>([])
  const [otpCodeHasError, setOtpCodeHasError] = useState<boolean>(false)
  const [showSuccessOrError, setShowSuccessOrError] = useState(false)
  const [showTimeError, setShowTimeError] = useState(false)
  const [verifyCode, setVerifyCode] = useState<number>()
  const [googleAuthActivateCodeErrorText, setGoogleAuthActivateCodeErrorText] =
    useState(false)
  const [buttonClicked, setButtonClicked] = useState(0)
  const activeLang = languages.find((row) => row.label === loggedUserInfo?.lang)

  const getLoggedUserData = async () => {
    const data = await getLoggedUserInfo()

    setLoggedUserInfo((old_data) => data)
  }

  useEffect(() => {
    let userData = secureLocalStorageGet('userData')
    getLoggedUserData()
  }, [])

  useLayoutEffect(() => {
    setGoogleAuthStatus((old_data) => getUserData()?.isTOTPEnabled)
  }, [])

  const googleAuthBtnClass = googleAuthStatus ? 'active' : ''

  const dropDownMenus = (
    <Menu
      style={{ width: 58 }}
      className="has_hover_dropdown header-dropdown-menu system_lang-dropdown-menu"
    >
      {languages.map((row) => {
        return !row.active && <Menu.Item>{row.label}</Menu.Item>
      })}
    </Menu>
  )

  const onOptionsChange = (e) => {
    const new_val = e.target.value
    const selected_option = options.find((row) => row.value == new_val)

    setOptionValue((old_value) => new_val)
    setSelectedOptionRow((old_data) => selected_option)
  } 
  const formatRemainingTime = (time: number) => {
    const minutes = Math.floor((time % 1200) / 60)
    const seconds = time % 60

    return `0${minutes}:${seconds == 0 || seconds < 10 ? `0${seconds}` : seconds}`
  }
  const renderTime = ({ remainingTime }) => {
    if (remainingTime === 0) {
      return <div className="timer"></div>
    }

    return (
      <div className="timer">
        <div className="value">{formatRemainingTime(remainingTime)}</div>
      </div>
    )
  }
  const closeAndOpenModal = (next_step: string) => {
    if (next_step == 'closeAll') {
      setActivateModalVisible((old_data) => activateModalVisibleReset)
      resetForm(form)
    } else {
      setActivateModalVisible((old_data) => ({
        ...activateModalVisibleReset,
        [next_step]: true,
      }))
    }
  }

  useEffect(() => {
    if (!smsClicked) {
      let timer1 = setInterval(() => setClicked(true), 20 * 1000)
      return () => {
        clearInterval(timer1)
      }
    }
  }, [buttonClicked, smsClicked])

  const updateGoogleAuthStatus = () => {
    if (googleAuthStatus) {
      //disabled et

      disableGoogleAuth().then((res) => {
        setActivateModalVisible({
          ...activateModalVisibleReset,
          showStep5: true,
        })

        setClicked(false)
        setButtonClicked(buttonClicked + 1)
        form.resetFields(['disabledSmsCode'])
        setSmsCode((old_value) => '')
        setSmsCodeFieldErrorText(false)
      })
    } else {
      //enable et
      setActivateModalVisible({ ...activateModalVisibleReset, showStep1: true })
    }
  }

  /**/

  const goToGoogleAuthStep2 = async () => {
    enableGoogleAuth().then((res) => {
      closeAndOpenModal('showStep2')

      setClicked(false)
      setButtonClicked(buttonClicked + 1)
      form.resetFields(['sms_code_activate'])
      setSmsCode((old_value) => '')
      setSmsCodeFieldErrorText(false)
    })
  }

  const checkSmsCode = (step: string) => {
    if (smsCode?.length == 5) {
      const req_data = {
        // userName: localStorage.getItem('username'),
        userName: secureLocalStorageGet('username'),
        verfication: smsCode,
      }

      checkGoogleAuthSmsCode(req_data).then((res) => {
        closeAndOpenModal(step)
        setSmsCode((old_value) => '')

        if (step === 'showStep3') {
          //enable and get qrcode and verify code
          let messages = res.messages

          setQrCode((old_data) => (messages[0] ? messages[0]?.MESSAGE : ''))
          setQrCodeImage((old_data) =>
            messages[0] ? messages[0]?.MESSAGE : ''
          )
        } /*else if(step==='showStep4'){
                    //enabled finish
                    let new_data={...getUserData(), isTOTPEnabled: true}

                    localStorage.setItem('userData', JSON.stringify(new_data))

                    setGoogleAuthStatus(old_data => true)

                }*/ else if (step === 'showStep6') {
          //disabled
          let new_data = { ...getUserData(), isTOTPEnabled: false }

          // localStorage.setItem('userData', JSON.stringify(new_data))

          secureLocalStorageSet('userData', new_data)

          setGoogleAuthStatus((old_data) => false)
        }
      })
    }

    if (smsCode?.length === 0 || smsCode?.length === undefined) {
      setSmsCodeFieldErrorText(true)
    }
  }

  const activateGoogleAuth = () => {
    if (
      googleAuthActivateCode?.length === 0 ||
      googleAuthActivateCode === null ||
      googleAuthActivateCode === undefined
    ) {
      setGoogleAuthActivateCodeErrorText(true)
    } else {
      const req_data = {
        secret: QrCode,
        verfication: googleAuthActivateCode,
      }

      googleAuthCodeVerify(req_data).then((res) => {
        //enabled finish
        let new_data = { ...getUserData(), isTOTPEnabled: true }

        // localStorage.setItem('userData', JSON.stringify(new_data))
        secureLocalStorageSet('userData', new_data)

        setGoogleAuthStatus((old_data) => true)

        getLoggedUserData()

        closeAndOpenModal('showStep4')
      })
    }
  }

//   const resetFormTimer = () => {
//     /*setValue('')
//         setNotify(false)
//         .resetFields()*/
//   }

  const reSendSms = (val: string) => {
    if (val === 'enable') {
      enableGoogleAuth()
    } else if (val === 'disable') {
      disableGoogleAuth()
    }

    setClicked(false)
  }

    const handleSecretKey = async() =>{
        const data = await getSecretKey()
      
    }

    const showOtpCodeModal =async () => {
        let phone_number:any = secureLocalStorageGet('phoneNumber')
                                      if (phone_number === undefined || phone_number === "" || phone_number === null)
                                        phone_number = loggedUserInfo?.phoneNumber
                                      if (phone_number !== undefined && phone_number !== "" && phone_number !== null) {
                                          let last_4_number = phone_number.slice(-4)
                                          let make_phone_number =
                                              last_4_number[0] +
                                              last_4_number[1] +
                                              '-' +
                                              last_4_number.slice(-2)
                                          setPhoneNumber((old_data) => make_phone_number)
                                      }
        // setNextModalVisible(false)
          const data = await getSecretKey()
          setOtpCodeModalVisible(true);
          setClicked(false)
          setOtpCode((old_data) => [])
          setOtpCodeHasError((old_data) => false)
    }

    const hideSecretWord = () => {
        setShowSecretWord(false)
        
    }
    const hideOtpCodeModal = () => {
        setNextModalVisible(true)
        setOtpCodeModalVisible(false)
    }
    const checkOTPCode = () => {
           
           const userName = loggedUserInfo?.userName
            if (otpCode.length == 5 || otpCode.length == 6) {
                const req = {"userName":userName,"verfication":otpCode}
                getSecretKeyVerify(req).then((res) => {
                    setOtpCodeModalVisible(false)
                    setShowSecretWord(true)
                    setSecretWord(res.data?.secret)
                    
                }).catch((e) => {
                    // setOtpCodeModalVisible(false)
                    setShowSuccessOrError(true)
                    setOtpCodeHasError(true)
                })
            }
        }
        const handleValue = (value: any) => {
            setOtpCode(value)
        }
    let channel = secureLocalStorageGet('channel')
        
    const resetFormTimer = () => {
        setOtpCodeModalVisible(false)
        setShowTimeError(true)
        // inputRef.current.__clearvalues__()
    }
    const resetSecretTimer = () =>{
        setShowSecretWord(false)
        hideSecretWord()
    }
    const reSend = () => {
        if (smsClicked) {
            setClicked(false)
            handleSecretKey()
        }
        // setMinutes(5);
        // setReset(true);
        // setTimeout(() => setReset(false), 1000);
    }

  return (
    <>
      <div className={'settings_sides settings_right_side'}>
        <ul
          className={
            'flex direction_column full settings_list setting_right_list'
          }
        >
          <li>
            <span>{t('settings.surname')}</span>
            <p>{loggedUserInfo?.customerLastName}</p>
          </li>

          <li>
            <span>{t('requisites.name')}</span>
            <p>{loggedUserInfo?.customerName}</p>
          </li>

          <li>
            <span>{t('settings.middleName')}</span>
            <p>{loggedUserInfo?.customerAtaAdi}</p>
          </li>

          <li>
            <span>{t('settings.messageLanguage')}</span>

            <Dropdown
              overlay={dropDownMenus}
              className={'has_hover_dropdown settings_lang_drop_down'}
              placement="bottomRight"
            >
              <Button
                className="transparent flex align_center setting_system_lang_btn"
                type={'ghost'}
              >
                <p>{activeLang?.label}</p>
                <DropdownIco />
              </Button>
            </Dropdown>
          </li>

          <li>
            <span>Login</span>
            <p>{loggedUserInfo?.userName}</p>
          </li>

          <li>
            <span>{t('login.mobileNumber')}</span>
            <p>{loggedUserInfo?.phoneNumber}</p>
          </li>

          <li>
            <span>{t('requisites.email')}</span>
            <p>{loggedUserInfo?.email}</p>
          </li>

          <li>
            <div style={{display:'flex' ,alignItems:'center'}}>
              <span style={{ alignContent: 'center' }}>
                {t('orders.salaryCardOrder.tableTitles.codeWord')}
              </span>
              <Button onClick={showSecretWord ?hideSecretWord :showOtpCodeModal} className="eyeicon-button">
                <span style={{display:'flex'}}>{showSecretWord ?<EyeIcon/> :<ClosedEyeIcon />}</span>
              </Button>
             {showSecretWord && <Timer style={{color:"#F3646C"}} time={1} timerEnd={resetSecretTimer}/>}
            </div>
            <p>{showSecretWord ? secretWord : "*****" }</p>
          </li>

          <li>
            <span>{t('settings.googleAuth')}</span>

            <div className={'flex align_center responsive-activate-GA'}>
              <p>
                {googleAuthStatus
                  ? `${loggedUserInfo?.TOTPChangeDate ?? ''} ${t(
                      'settings.activated'
                    )}`
                  : t('settings.notActivated')}
              </p>

              <Button
                type={'ghost'}
                className={`transparent setting_activate_google_auth_btn ${googleAuthBtnClass}`}
                onClick={() => {
                  updateGoogleAuthStatus()
                }}
              >
                {googleAuthStatus
                  ? t('settings.deactivate')
                  : t('businessCards.activate')}
              </Button>
            </div>
          </li>
        </ul>
      </div>

      {/* Google Auth Activate Modal 1*/}
      <Modal
        title={t('settings.activateGoogleAuthenticator')}
        closeIcon={
          <Button
            type={'ghost'}
            onClick={() =>
              setActivateModalVisible({ ...activateModalVisibleReset })
            }
            icon={<ModalCloseIco />}
          />
        }
        centered
        visible={activateModalVisible.showStep1}
        okText={t('accountStatement.apply')}
        okButtonProps={{ className: 'modal_ok_btn' }}
        cancelText={'Ləğv et'}
        cancelButtonProps={{ className: 'modal_cancel_btn' }}
        width={730}
        className={
          'manage_faster_menus google_auth_modal google_auth_modal_activate_1'
        }
        keyboard={false}
        focusTriggerAfterClose={false}
        footer={
          <div className="flex justify_end align_center">
            <Button
              type="button"
              className="modal_cancel_btn  "
              onClick={() =>
                setActivateModalVisible({ ...activateModalVisibleReset })
              }
            >
              {t('common.doCancel')}
            </Button>
            <Button
              type="primary"
              className="modal_ok_btn "
              onClick={goToGoogleAuthStep2}
            >
              {t('newTransfer.nextButton')}
            </Button>
          </div>
        }
      >
        <div className="responsive-setting-modal-activate-GA">
          <div className={'full flex direction_column google_auth_modal_body'}>
            <p>{t('settings.selectOStype')}</p>

            <Radio.Group
              className={
                'receiver_bank_options full justify_center flex google_auth_phone_options'
              }
              options={options}
              value={optionValue}
              onChange={onOptionsChange}
            />

            <div className={'full flex direction_column qr_code_box'}>
              <p>
                {t('settings.viewqrcode1')}{' '}
                <Button
                  type={'link'}
                  className={'transparent'}
                  onClick={() => {
                    setVisibleQrCode((old_data) => !visibleQrCode)
                  }}
                >
                  {t('settings.viewqrcode2')}
                </Button>{' '}
                {t('settings.viewqrcode3')}
              </p>
              {visibleQrCode && (
                <img src={qr_codes[selectedOptionRow?.value]} />
              )}
            </div>

            <div className={'full flex direction_column qr_code_info_box'}>
              <p>
                {t('settings.additionalInfo1')}
                <a
                  href={
                    selectedOptionRow?.value === 1
                      ? 'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2'
                      : selectedOptionRow?.value === 2
                      ? 'https://itunes.apple.com/cz/app/google-authenticator/id388497605'
                      : null
                  }
                  type={'link'}
                  className={'transparent google_auth_hereLink'}
                  target="_blank"
                >
                  {t('settings.additionalInfo2')}
                </a>
                {t('settings.additionalInfo3')}
              </p>
            </div>

            <div className={'full flex direction_column qr_code_info_box2'}>
              <p>{t('settings.clickNextButton')}</p>
            </div>
          </div>
        </div>
      </Modal>

      {/* Google Auth Activate Modal 2*/}
      <Modal
        title={t('settings.activateGoogleAuthenticator')}
        closeIcon={
          <Button
            type={'ghost'}
            onClick={() =>
              setActivateModalVisible({ ...activateModalVisibleReset })
            }
            icon={<ModalCloseIco />}
          />
        }
        centered
        visible={activateModalVisible.showStep2}
        okText={t('accountStatement.apply')}
        okButtonProps={{ className: 'modal_ok_btn' }}
        cancelText={'Ləğv et'}
        cancelButtonProps={{ className: 'modal_cancel_btn' }}
        width={580}
        className={
          'manage_faster_menus manage_template_modal google_auth_modal google_auth_modal_activate_2'
        }
        keyboard={false}
        focusTriggerAfterClose={false}
        footer={
          <div className="flex justify_end align_center">
            <Button
              type="button"
              className="modal_cancel_btn  "
              onClick={() => closeAndOpenModal('showStep1')}
            >
              {t('transfers.back')}
            </Button>
            <Button
              type="primary"
              className="modal_ok_btn "
              onClick={() => {
                checkSmsCode('showStep3')
              }}
            >
              {t('login.confirm')}
            </Button>
          </div>
        }
      >
        <div className={'full flex direction_column google_auth_modal_body'}>
          <p>{t('settings.confirmBySMSCode')}</p>

          <div
            className={'full flex direction_column google_auth_activate_box'}
          >
            <span>{t('settings.enterSMS')}</span>

            <div className="smsCodeFieldDiv">
              <Form form={form}>
                <InputField
                  name={'sms_code_activate'}
                  type={'text'}
                  isNumeric={true}
                  onlyNumber={true}
                  maxLength={5}
                  value={smsCode}
                  onKeyUp={(e) => {
                    setSmsCode((old_data) => e.target.value)
                    setSmsCodeFieldErrorText((old_data) => false)
                  }}
                  form={form}
                />
              </Form>
              {smsCodeFieldErrorText ? (
                <div className="smsCodeFieldErrorText">
                  {t('settings.enterCode')}
                </div>
              ) : (
                <></>
              )}
            </div>

            <div className={'full flex align_center google_auth_counter_box'}>
              <div
                className={
                  'google_auth_counter flex align_center justify_center'
                }
              >
                {activateModalVisible.showStep2 ? (
                  <Timer
                    timerEnd={resetFormTimer}
                    buttonClicked={buttonClicked}
                  />
                ) : (
                  <span>00:00</span>
                )}
              </div>
              <a
                onClick={() => {
                  reSendSms('enable')
                }}
                className={
                  smsClicked
                    ? 'active reSendAuth'
                    : 'reSendAuthDisable reSendAuth'
                }
              >
                {t('settings.detailsData')}
              </a>
            </div>
          </div>
        </div>
      </Modal>

      {/* Google Auth Activate Modal 3*/}
      <Modal
        title={t('settings.activateGoogleAuthenticator')}
        closeIcon={
          <Button
            type={'ghost'}
            onClick={() =>
              setActivateModalVisible({ ...activateModalVisibleReset })
            }
            icon={<ModalCloseIco />}
          />
        }
        centered
        visible={activateModalVisible.showStep3}
        okText={t('accountStatement.apply')}
        okButtonProps={{ className: 'modal_ok_btn' }}
        cancelText={'Ləğv et'}
        cancelButtonProps={{ className: 'modal_cancel_btn' }}
        width={730}
        className={
          'manage_faster_menus manage_template_modal google_auth_modal google_auth_modal_activate_3'
        }
        keyboard={false}
        focusTriggerAfterClose={false}
        footer={
          <div className="flex justify_end align_center">
            <Button
              type="button"
              className="modal_cancel_btn  "
              onClick={() => closeAndOpenModal('showStep2')}
            >
              {t('transfers.back')}
            </Button>
            <Button
              type="primary"
              className="modal_ok_btn "
              onClick={activateGoogleAuth}
            >
              {t('login.confirm')}
            </Button>
          </div>
        }
      >
        <div className={'full flex direction_column google_auth_modal_body'}>
          <div className={'full flex direction_column'}>
            <p>{t('settings.openGoogleAuthApp')}</p>

            <ul
              className={'full flex direction_column google_auth_modal_ul_list'}
            >
              <li>
                <p>{t('settings.scanQRCode')}</p>
              </li>
              <li>
                <p>{t('settings.useCameraForQR')}</p>
              </li>
            </ul>
          </div>

          <div className={'full flex google_auth_step_3_scan_qr_code_box'}>
            <div
              className={'full flex align_center justify_center qr_code_box'}
            >
              <GoogleAuthenticator
                value={QrCode}
                user={secureLocalStorageGet('username')}
              />
            </div>

            <div
              className={
                'full flex direction_column google_auth_step_3_scan_right_box'
              }
            >
              <p>{t('settings.enterWithCode')}</p>

              <div
                className={
                  'full flex align_center justify_center show_qr_code_box_2'
                }
              >
                <Form form={form}>
                  <InputField
                    disabled={true}
                    name={'qr_code'}
                    value={showQrCode ? QrCode : ''}
                    type={'text'}
                    form={form}
                  />
                </Form>

                {!showQrCode && (
                  <Button
                    type={'link'}
                    className={'transparent resend_google_auth_code'}
                    onClick={() => setShowQrCode((old_data) => true)}
                  >
                    {t('settings.showCode')}
                  </Button>
                )}
              </div>

              <p>{t('settings.confirm6DigitCode')}</p>

              <div
                className={
                  'full flex direction_column google_auth_activate_box'
                }
              >
                <span>{t('settings.enter6DigitCode')}</span>
                <div className="smsCodeFieldDiv">
                  <Form form={form}>
                    <InputField
                      name={'google_auth_code'}
                      type={'text'}
                      isNumeric={true}
                      onlyNumber={true}
                      maxLength={6}
                      value={googleAuthActivateCode}
                      onKeyUp={(e) => {
                        setGoogleAuthActivateCode((old_data) => e.target.value)
                        setGoogleAuthActivateCodeErrorText((oldData) => false)
                      }}
                      form={form}
                    />
                  </Form>
                  {googleAuthActivateCodeErrorText ? (
                    <div className="smsCodeFieldErrorText">
                      {t('settings.enterCode')}
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>

      {otpCodeModalVisible && (
                <Modal
                    title={'SMS-kod ilə imzalama'}
                    closeIcon={<ModalCloseIco />}
                    centered
                    open={otpCodeModalVisible}
                    onOk={hideOtpCodeModal}
                    onCancel={hideOtpCodeModal}
                    width={422}
                    className={`manage_faster_menus swift_modal form_next_modal otp_code_verify_modal`}
                    keyboard={false}
                    focusTriggerAfterClose={false}
                    footer={false}
                    maskClosable={false}
                >
                    <div
                        className={
                            'flex direction_column align_center otp_code_verify_modal_body'
                        }
                    >

                          <p>
                                {t("settings.otpcode1")}{"**"+phoneNumber} {t("settings.otpcode2")} <br />
                                {t("settings.otpcode3")}
                            </p>
                            
                            
                        
                        <Form
                            form={form}
                            onSubmit={(e: any) => e.preventDefault()}
                            onFinish={checkOTPCode}
                            shouldAutoFocus={true}
                            autoComplete="off"
                            className={
                                otpCodeHasError
                                    ? 'message-input-form flex direction_column justify_center has_error'
                                    : 'flex direction_column justify_center message-input-form'
                            }
                        >
                            <OtpInput
                                value={otpCode}
                                onChange={handleValue}
                                numInputs={5}
                                inputStyle="otpInput"
                                isInputNum={true}
                                shouldAutoFocus={true}
                                className="message-input-form__input"
                            />

                            {otpCodeHasError && (
                                <span className={'verify_code_error flex full justify_center'}>
                    Yanlış kod daxil edilib!
    </span>
                            )}

                            <div className={'full flex direction_column'}>
                                <ul
                                    className="message-form__details full"
                                    style={{ marginTop: otpCodeHasError ? 16 : 21 }}
                                >
                                    <li className="message-form__time">
                                        <Timer timerEnd={resetFormTimer} reset={false} />
                                    </li>
                                    <li>
                                       
                                        <a onClick={reSend} className={(smsClicked) ? 'active' : 'disabled'}>SMS kodu yenidən göndər</a>
                                        
                                    </li>
                                </ul>

                                {/*<Button*/}
                                {/*  type={'ghost'}*/}
                                {/*  className={'transparent resend_verify_code_btn' + smsClicked ? 'active' : 'disabled'}*/}
                                {/*  onClick={reSend}*/}
                                {/*>*/}
                                {/*  SMS kodu yenidən göndər*/}
                                {/*</Button>*/}

                                <div className="login-form__buttons flex justify_center">
                                    <Button
                                        size={'large'}
                                        className="prev ant-btn ant-btn-lg light-button refresh_btn btn flex align_center justify_center"
                                        onClick={hideOtpCodeModal}
                                    >
                                        Geriyə
                                    </Button>
                                    <Button
                                        size={'large'}
                                        className="next ant-btn ant-btn-lg blue-button next_btn btn flex align_center justify_center"
                                        htmlType="submit"
                                    >
                                        Təsdiq et
                                    </Button>
                                </div>
                            </div>
                        </Form>
                    </div>
                </Modal>
            )}
      {/* Google Auth Activate Modal 4*/}

      <SuccessOrErrorModal
        visible={activateModalVisible.showStep4}
        modalType={'success'}
        modalTitle={t('notification.attention')}
        modalText={t('settings.activatedGoogleAuth')}
        onCloseText={'OK'}
        onClose={() => {
          closeAndOpenModal('closeAll')
        }}
        className={'google_auth_modal google_auth_modal_activate_2'}
      />

      {/* Google Auth Activate Modal 5*/}
      <Modal
        title={t('settings.deactivateGoogleAuth')}
        closeIcon={
          <Button
            type={'ghost'}
            onClick={() =>
              setActivateModalVisible({ ...activateModalVisibleReset })
            }
            icon={<ModalCloseIco />}
          />
        }
        centered
        visible={activateModalVisible.showStep5}
        okText={t('accountStatement.apply')}
        okButtonProps={{ className: 'modal_ok_btn' }}
        cancelText={'Ləğv et'}
        cancelButtonProps={{ className: 'modal_cancel_btn' }}
        width={580}
        className={
          'manage_faster_menus manage_template_modal google_auth_modal google_auth_modal_disable_1 google_auth_modal_activate_2'
        }
        keyboard={false}
        focusTriggerAfterClose={false}
        footer={
          <div className="flex justify_end align_center">
            <Button
              type="button"
              className="modal_cancel_btn  "
              onClick={() =>
                setActivateModalVisible({ ...activateModalVisibleReset })
              }
            >
              {t('common.doCancel')}
            </Button>
            <Button
              type="primary"
              className="modal_ok_btn "
              onClick={() => {
                checkSmsCode('showStep6')
              }}
            >
              {t('login.confirm')}
            </Button>
          </div>
        }
      >
        <div className={'full flex direction_column google_auth_modal_body'}>
          <p>{t('settings.confirmDeactivation')}</p>

          <div
            className={'full flex direction_column google_auth_activate_box'}
          >
            <span>{t('settings.enterSMS')}</span>
            <div className="smsCodeFieldDiv">
              <Form form={form}>
                <InputField
                  name={'disabledSmsCode'}
                  type={'text'}
                  isNumeric={true}
                  onlyNumber={true}
                  maxLength={5}
                  value={smsCode}
                  onKeyUp={(e) => {
                    setSmsCode((old_data) => e.target.value)
                    setSmsCodeFieldErrorText((old_data) => false)
                  }}
                  form={form}
                />
              </Form>
              {smsCodeFieldErrorText ? (
                <div className="smsCodeFieldErrorText">
                  {t('settings.enterCode')}
                </div>
              ) : (
                <></>
              )}
            </div>

            <div className={'full flex align_center google_auth_counter_box'}>
              <div
                className={
                  'google_auth_counter flex align_center justify_center'
                }
              >
                {activateModalVisible.showStep5 ? (
                  <Timer
                    timerEnd={resetFormTimer}
                    buttonClicked={buttonClicked}
                  />
                ) : (
                  <span>00:00</span>
                )}
              </div>
              <a
                onClick={() => {
                  reSendSms('disable')
                }}
                className={
                  smsClicked
                    ? 'active reSendAuth'
                    : 'reSendAuthDisable reSendAuth'
                }
              >
                {t('settings.detailsData')}
              </a>
            </div>
          </div>
        </div>
      </Modal>

      {/* Google Auth Activate Modal 6*/}

      <SuccessOrErrorModal
        visible={activateModalVisible.showStep6}
        modalType={'success'}
        modalTitle={t('notification.attention')}
        modalText={t('settings.deactivatedGoogleAuth')}
        onCloseText={'OK'}
        onClose={() => {
          closeAndOpenModal('closeAll')
        }}
        className={'google_auth_modal google_auth_modal_activate_2'}
      />
    </>
  )
}
const mapStateToProps = (state: any) => ({
  leftMenuStatus: state.home.leftMenuStatus,
})
export default connect(mapStateToProps, null)(Profile)
